import { render, staticRenderFns } from "./refund_detail.vue?vue&type=template&id=487adac6&scoped=true"
import script from "./refund_detail.vue?vue&type=script&lang=js"
export * from "./refund_detail.vue?vue&type=script&lang=js"
import style0 from "./refund_detail.vue?vue&type=style&index=0&id=487adac6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "487adac6",
  null
  
)

export default component.exports